export default __webpack_public_path__ + "static/media/ghost-negative.5dc40d9c.svg";